import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { UserPermissionsStore } from '../../store/user-permissions.store';
import { isPermissionDeniedError } from '../utils/permission-denied-error.util';

export const PERMISSION_RELOAD_THROTTLE_MS = 10_000;

let lastReloadAt = Number.NEGATIVE_INFINITY;

export const permissionDeniedInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (isPermissionDeniedError(error) && !req.url.includes('/permissions/me')) {
        // Resolved here, not at construction: the store's HttpClient runs through this interceptor (DI cycle).
        const userPermissionsStore = injector.get(UserPermissionsStore);
        if (userPermissionsStore.status() !== 'idle' && Date.now() - lastReloadAt >= PERMISSION_RELOAD_THROTTLE_MS) {
          lastReloadAt = Date.now();
          userPermissionsStore.load();
        }
      }
      return throwError(() => error);
    })
  );
};
